import React from 'react';
import { StyleSheet, Text } from 'react-native';
import { COLORS } from '../../styles/colors';
import { fontFamilies } from '../../utils/fontLoader';

/**
 * A reusable text component for body content with predefined sizes.
 * @param {object} props - The component props.
 * @param {'large' | 'medium'} [props.size='medium'] - The size variant of the body text.
 * @param {React.ReactNode} props.children - The text content.
 * @param {object} [props.style] - Additional custom styles to apply.
 * @returns {JSX.Element}
 */
const BodyText = ({ size = 'medium', children, style, ...props }) => {
  const textStyle = [styles.base, styles[size], style];

  return (
    <Text style={textStyle} {...props}>
      {children}
    </Text>
  );
};

const styles = StyleSheet.create({
  base: {
    color: COLORS.textPrimary,
  },
  large: {
    fontFamily: fontFamilies.satoshi.light,
    fontSize: 20,
    lineHeight: 20 * 1.6,
  },
  medium: {
    fontFamily: fontFamilies.satoshi.regular,
    fontSize: 16,
    lineHeight: 16 * 1.6,
  },
});

export default BodyText;
